import { useCallback } from 'react';
import type { CreateNewMapContainerProps } from '~/map/createNew/createNewMap.container';
import type { WithoutModalProps } from '~/modal/modalRegistry.type';
import { useModal } from '~/modal/useModal.hook';

export const useCreateNewMap = () => {
  const { openModal: openCreateNewMapModal } = useModal('CreateNewMap');

  const onCreateNewMap = useCallback((props?: WithoutModalProps<CreateNewMapContainerProps>) => {
    openCreateNewMapModal(props ?? {});
  }, [openCreateNewMapModal]);

  return { onCreateNewMap };
};
